import { useTranslation } from "react-i18next";
import { Paperclip } from "lucide-react";

interface AttachmentIndicatorProps {
  count: number;
}

export const AttachmentIndicator = ({ count }: AttachmentIndicatorProps) => {
  const { t } = useTranslation("messages");
  return (
    <div className="flex items-center gap-1 mt-2 text-xs opacity-75">
      <Paperclip className="h-3 w-3" />
      <span>{t("{{count}} attachment", { count })}</span>
    </div>
  );
};
